import * as React from "react";
import TeaserGrid, { ITeaserGridProps } from "~/components/teaser-grid/teaser-grid";

export interface ITeaserGridViewProps {
    contextModel: ITeaserGridProps;
}

class TeaserGridView extends React.PureComponent<ITeaserGridViewProps> {
    public render() {
        return <TeaserGrid {...this.props.contextModel} />;
    }
}

export default TeaserGridView;
